import { Component, Input, OnChanges, TemplateRef, ViewChild, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { State } from '@app/core/ngrx/reducers';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ImageSlideComponent } from '@app/shared/components/image-slide/image-slide.component';
import { isLastMinute } from '@app/shared/utils/lastminute';
import { applicationSelectors } from '@core/ngrx/selectors';
import { userSelectors } from '@app/core/ngrx/selectors';
import { ModalService } from '@core/services/modal/modal.service';
import { faArrowDown, faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { ModalController, PopoverController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { ApplicationQuickActionsMobileComponent } from '../application-quick-actions-mobile/application-quick-actions-mobile.component';
import { filter, take } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

// import { ImageSlideComponent } from '../image-slide/image-slide.component';
// import { MobileCustomerActionsComponent } from '../mobile-customer-actions/mobile-customer-actions.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-nonbooking-payment',
    templateUrl: './application-payment-action.component.html',
    styleUrls: ['./application-payment-action.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, ImgPipe, FontAwesomeModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplicationPaymentActionComponent implements OnChanges {
    censorContent$ = this.store.pipe(select(userSelectors.blockContent)); // visitor block content if 'unmanaged'

    data = {
        header: '',
        topMessage: '',
        bottomMessage: '',
        class: 'sidebar-modal-md',
    };

    icons: any = {
        exclamation: faExclamationCircle,
        arrow: faArrowDown,
    };

    textcontent: any;

    @Input() application: any;

    expandNonBookingCard = false;
    newBooking = false;

    sliderOpts = {
        initialSlide: 0,
        speed: 400,
        scrollbar: true,
        slidesPerView: 1,
        centeredSlides: true,
    };

    firstPayment = false;

    hideButton = this.paymentService.getShowMeTheMoney();

    lastMinute = false;

    images = [];

    lateFee$: Observable<number> = this.store.select(applicationSelectors.getLateFee);
    isLate$: Observable<boolean> = this.store.select(applicationSelectors.getIsLate);
    date$: Observable<any> = this.store.select(applicationSelectors.getDeadline);
    remain$: Observable<number> = this.store.select(applicationSelectors.getRemaining);
    program_deadlinedays$: Observable<number> = this.store.select(applicationSelectors.getProgramDeadlineDays);
    message$: Observable<string> = this.store.select(applicationSelectors.getDeadlineMessage);

    overlayRef: OverlayRef | null; // right click menu check
    @ViewChild('navMenu') navMenu: TemplateRef<any>; // ng template for right click menu
    sub: Subscription;

    constructor(
        private popoverCtrl: PopoverController,
        private paymentService: PaymentService,
        private modalService: ModalService,
        private toolService: ToolService,
        private store: Store<State>,
        private modalCtrl: ModalController,
        public overlay: Overlay,
        public viewContainerRef: ViewContainerRef
    ) {
        this.toolService.content.subscribe((textcontent: any) => (this.textcontent = textcontent));

        this.program_deadlinedays$.subscribe((days) => {
            /* empty */
        });
    }

    async ngOnChanges() {
        if (this.application) {
            if (this.application.program.lastminute === true) {
                this.lastMinute = isLastMinute(this.application);
            }
            if (this.application.program.image.length > 0) {
                this.application.program.image.forEach((image) => {
                    const arr = [];
                    if (image.size === 'md') {
                        arr.push(image);
                        this.images.push(arr);
                    }
                });
            }

            let checkForUnmanaged;
            this.censorContent$.subscribe((data: boolean) => {
                checkForUnmanaged = data;
            });
        }
    }

    openInformationModal() {
        this.data.header = `${this.textcontent.shared.nonbookingPayment.modalHeader}`;
        this.data.bottomMessage = `${this.textcontent.shared.nonbookingPayment.modalContent}`;
        this.modalService.basicInfoAlert(this.data).then((response: any) => {
            // console.log(response);
        });
    }

    openPreview = (img: any, i: number) => {
        this.modalCtrl
            .create({
                component: ImageSlideComponent,
                cssClass: 'image-slider-modal',
                componentProps: {
                    image: img,
                    index: i,
                    program: this.application.program,
                },
            })
            .then((modal) => {
                modal.present();
            });
    };

    async moreActions(ev: any) {
        const popover = await this.popoverCtrl.create({
            component: ApplicationQuickActionsMobileComponent,
            mode: 'md',
            event: ev,
            animated: true,
            backdropDismiss: true,
            componentProps: {
                application: this.application,
            },
        });
        return popover.present();
    }

    lastMinuteCharged(event: string) {
        this.paymentService.paymentTypeMoney.next(event);
    }

    cancelPayment() {
        this.paymentService.showMeMoney.next(false);
    }

    /**
     *
     * @param event mouse event, use coordinates to build template on
     * @param selectedTab string value of selected tab
     */
    open({ x, y }: MouseEvent, selectedTab: string) {
        selectedTab = `search?tags=${selectedTab}`;
        // this try catch for event might not work later
        // need another way to add to params for event
        try {
            // eslint-disable-next-line import/no-deprecated
            event.preventDefault();
        } catch (err) {
            throw err;
        }

        this.close();
        // setup for context menu template
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo({ x, y })
            .withPositions([
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                },
            ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close(),
        });
        // use ng template reference and attach tab string to it
        this.overlayRef.attach(
            new TemplatePortal(this.navMenu, this.viewContainerRef, {
                $implicit: selectedTab,
            })
        );

        this.sub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter((event) => {
                    const clickTarget = event.target as HTMLElement;
                    return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
                }),
                take(1)
            )
            .subscribe(() => this.close());
    }

    /**
     * closes context menu
     */
    close() {
        this.sub && this.sub.unsubscribe();
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }

    /**
     *
     * @param tab sting value for tab selected by right click context menu
     *
     */
    openNewTab(tab: string) {
        const url = window.location.origin;
        window.open(`${url}/${tab}`, '_blank');
        this.close();
    }
}
